import { Money } from '@afterpay/types'
import { parseMoneyValue } from '../giftCardPromotion/parseGiftCardPromoBreakdown'

export interface GiftCardDetails {
  name: string | null
  imageUrl: string | null
  faceValue: Money | null
}

const EMPTY_GIFT_CARD_DETAILS: GiftCardDetails = { name: null, imageUrl: null, faceValue: null }

export const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null && !Array.isArray(value)

export const parseNonEmptyString = (value: unknown): string | null => (typeof value === 'string' && value.trim() !== '' ? value.trim() : null)

const parseHttpsUrl = (value: unknown): string | null => {
  const candidate = parseNonEmptyString(value)
  if (candidate === null) {
    return null
  }
  try {
    return new URL(candidate).protocol === 'https:' ? candidate : null
  } catch {
    return null
  }
}

export const parseGiftCardDetails = (custom: unknown): GiftCardDetails => {
  if (!isRecord(custom)) {
    return EMPTY_GIFT_CARD_DETAILS
  }

  return {
    name: parseNonEmptyString(custom.giftCardName),
    imageUrl: parseHttpsUrl(custom.giftCardImageUrl),
    faceValue: parseMoneyValue(custom.giftCardAmount),
  }
}
